<div class="flex flex-col h-screen overflow-hidden bg-[var(--bg-app)] text-[var(--ink)]">

  <!-- Navbar -->
  <app-navbar />

  <!-- Content -->
  <div #contentArea class="content-area flex-1 overflow-y-auto overflow-x-hidden bg-[var(--bg-app)]">
    <router-outlet></router-outlet>
  </div>

</div>